import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {

  }

  save() {
    this.dialogRef.close('true');
  }

  saveasDraft() {
    if(this.data?.crScopeConfirmDialog) {
      this.close();
    } else {
      this.dialogRef.close('save');
    }
  }


  close() {
    this.dialogRef.close('cancel');
  }

}
